import ainurposImg from '../assets/images/case-cover__pos-software.png';
import raifeisenImg from '../assets/images/case-cover__raifeisen.png';
import hseImg from '../assets/images/case-cover__HSE.png';
import playgroundImg from '../assets/images/case-cover__playground.png';
import streamyImg from '../assets/images/case-cover__streamy.png';
import panelImg from '../assets/images/case-cover__security-ecosystem.png';
import cynomiImg from '../assets/images/case-cover__vciso-platform.png';
import reislyImg from '../assets/images/case-cover__ai-native-workflow.png';
import impersonationImg from '../assets/images/case-cover__impersonation.png';

export const impersonationCaseData = {
  path: 'impersonation',
  image: impersonationImg,
  alt: 'Impersonation session interface',
  title: 'Impersonation',
  text: 'Safe, audited impersonation for a multi-tenant security platform, so teams can help users without the security tradeoff',
  exist: true,
};

export const ainurposCaseData = {
  path: 'ainurpos',
  image: ainurposImg,
  alt: 'AinurPOS image',
  title: 'POS Software',
  text: 'One-stop cloud based platform: warehouse, e-comm, online POS, sales, deliveries, employee and roles management, discounts, loyalty and customer CRM',
  exist: true,
};

export const homeTaskCaseData = {
  path: 'streamy',
  image: streamyImg,
  alt: 'streamy image',
  title: 'Streamy',
  text: 'Billing for the mobile app of the streaming service Streamy. Completed as part of the home assignment',
  exist: true,
};

export const ReislyCaseData = {
  path: 'ai-native-workflow',
  image: reislyImg,
  alt: 'Reisly',
  title: 'AI-native design workflow',
  text: "Moving prototyping from static screens into the product's codebase using real components, data, and AI-assisted workflows",
  exist: true,
  nda: false,
};

export const CynomiCaseData = {
  path: '',
  image: cynomiImg,
  alt: 'Cynomi image',
  title: 'vCISO platform',
  text: 'Complex multi-tenant cybersecurity platform for managed service providers and virtual CISO operations',
  exist: false,
  externalLink:
    'https://www.figma.com/design/EGrLfk3LYH11TU8hSSAtIi/vCISO-platform?node-id=0-1&t=tIGfBpLNYBZ9n6gf-1',
  externalLabel: 'OPEN WITH PASSWORD',
  showLock: true,
};

export const ParadoxCaseData = {
  path: '',
  image: panelImg,
  alt: 'Security Panel image',
  title: 'Security ecosystem',
  text: 'Multi-product security ecosystem including web, mobile, and security device interfaces',
  exist: false,
  externalLink:
    'https://www.figma.com/design/t7eg31M129gRPXgJW6356W/Security-Ecosystem?node-id=0-1&t=2eQVJ3RgF33WvVv4-1',
  externalLabel: 'OPEN WITH PASSWORD',
  showLock: true,
};

export const appplierCaseData = {
  path: 'Raiffeisen',
  image: raifeisenImg,
  alt: 'Raiffeisen image',
  title: 'More on Behance',
  text: 'An auto-payment feature for the Raiffeisen mobile bank, and an LMS feature for a university app',
  exist: false,
  externalLink: 'https://www.behance.net/krsgromov',
  externalLabel: 'VIEW ON BEHANCE',
};

export const hseCaseData = {
  path: 'hse-app',
  image: hseImg,
  alt: 'HSE App X image',
  title: 'HSE App X',
  text: 'A new feature of LMS (Learning Management System) mobile app for Higher School of Economics',
  exist: true,
};

export const playgroundCaseData = {
  path: 'hse-app',
  image: playgroundImg,
  alt: 'Playground image',
  title: 'Playground',
  text: 'My works from related areas of design, such as 3D, Motion and Illustration',
  exist: false,
};
